Object.filter = (obj, predicate) => 
    Object.keys(obj)
          .filter( key => predicate(obj[key]) )
          .reduce( (res, key) => (res[key] = obj[key], res), {} );


Number.roundToTwo = (num) => {
    return +(Math.round(num + "e+2")  + "e-2");
}